<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '司机姓名',
            value: 'companyName',
            type: 'select',
            options: [],
          },
          {
            label: '司机类型',
            value: 'lineName',
            type: 'select',
          },
          {
            label: '司机手机',
            value: 'linePhone',
            type: 'input',
          },
          {
            label: '身份证号',
            value: 'linePhone',
            type: 'input',
          },
          {
            label: '车牌号码',
            value: 'linePhone',
            type: 'input',
          },
          {
            label: '公司地址',
            value: 'address',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '名单类型',
            value: 'orgId',
            type: 'select',
          },
        ],
        rules: {
          companyName: [ // 客户全称
            { required: true, message: '请输入客户全称', trigger: 'blur' },
          ],
          lineName: [ // 联系人
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          linePhone: [ // 联系手机
            { required: true, message: '请输入联系手机', trigger: 'blur' },
          ],
          orgId: [ // 归属部门
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          address: [ // 公司地址
            { required: true, message: '请输入公司地址', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data) {
      const res = {
        companyName: data ? data.companyName : '',
        lineName: data ? data.lineName : '',
        linePhone: data ? data.linePhone : '',
        orgId: data ? data.orgId : '',
        address: data ? data.address : '',
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
